import consumer from "./consumer"

consumer.subscriptions.create("CallNotificationsChannel", {
  connected() {
    console.log("Connected to CallNotificationsChannel")
  },

  disconnected() {
    console.log("Disconnected from CallNotificationsChannel")
  },

  received(data) {
    console.log("Received call event:", data)
    
    // Only show banner on desktop (not mobile)
    if (!this.isMobile()) {
      this.displayBanner(data)
    }
  },

  isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  },

  displayBanner(eventData) {
    // Create a container for banners if it doesn't exist
    let container = document.getElementById('call-banners-container')
    if (!container) {
      container = document.createElement('div')
      container.id = 'call-banners-container'
      container.setAttribute('role', 'region')
      container.setAttribute('aria-live', 'polite')
      container.setAttribute('aria-label', 'Call notifications')
      container.style.cssText = 'position: fixed; top: 0; left: 0; right: 0; z-index: 10000; pointer-events: none;'
      document.body.appendChild(container)
    }

    // Create banner element
    const bannerId = `call-banner-${Date.now()}`
    const banner = document.createElement('div')
    banner.id = bannerId
    banner.className = 'call-banner'
    banner.setAttribute('role', 'alert')
    banner.dataset.controller = 'call-banner'
    banner.dataset.customerId = eventData.customer_id || ''
    banner.dataset.eventData = JSON.stringify(eventData)
    banner.style.cssText = 'pointer-events: auto;'
    
    banner.innerHTML = `
      <div class="call-banner-content">
        <div class="call-banner-icon" aria-hidden="true">📞</div>
        <div class="call-banner-info">
          <div class="call-banner-title">Call initiated from mobile</div>
          <div class="call-banner-details">
            <span class="call-banner-name">${eventData.customer_name || 'Unknown Contact'}</span>
            <span class="call-banner-separator"> - </span>
            <span class="call-banner-phone">${eventData.phone_number}</span>
          </div>
        </div>
        <div class="call-banner-actions">
          <button type="button" class="call-banner-btn call-banner-btn-primary" data-action="click->call-banner#navigate" aria-label="Open customer record">
            ${eventData.customer_id ? 'Open Record' : 'Search'}
          </button>
          <button type="button" class="call-banner-btn call-banner-btn-secondary" data-action="click->call-banner#dismiss" aria-label="Dismiss notification">
            Dismiss
          </button>
        </div>
      </div>
    `
    
    container.appendChild(banner)
    
    // Trigger display animation
    requestAnimationFrame(() => {
      banner.classList.add('call-banner-show')
    })
  }
})
